// extracted by mini-css-extract-plugin
export default {"description":"PueSI2","descriptionLargeDesktop":"uPwspy"};